import { get, HasPagingParameters, post } from "@insite/client-framework/Services/ApiService";
import { GetProductApiV2ParameterBase, GetProductCollectionApiV2Parameter, GetProductCollectionRealTimeInventoryApiV2Parameter, GetProductRealTimeInventoryApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import {
    ProductCollectionModel, RealTimeInventoryModel,
} from "@insite/client-framework/Types/ApiModels";

const realTimeInventoryUrl = "/api/v1/realtimeinventory";
const productsUrl = "/api/v2/products";

/* Poolcorp Custom Code */
export interface GetProductCollectionApiV2ParameterCustom extends GetProductCollectionApiV2Parameter, GetProductApiV2ParameterBase, HasPagingParameters {
    productNumbers?: string[];
}
/* Poolcorp Custom Code */

export function getProductCollectionV2(parameter: GetProductCollectionApiV2ParameterCustom) { // Poolcorp Custom Code
    if (!parameter.additionalExpands) {
        parameter.additionalExpands = [];
    }
    parameter.additionalExpands?.push("fulfillmentoptions");
    return get<ProductCollectionModel>(productsUrl, parameter);
}

export async function getProductRealTimeInventory(parameter: GetProductRealTimeInventoryApiV2Parameter) {
    const realTimeInventoryModel = await getProductCollectionRealTimeInventory({ // Poolcorp Custom Code - Use custom getProductCollectionRealTimeInventory
        expand: parameter.expand,
        productIds: [parameter.productId],
        additionalQueryStringParameters: parameter.additionalQueryStringParameters,
        configurations: parameter.configuration ? { [parameter.productId]: parameter.configuration } : undefined,
    });

    return realTimeInventoryModel.realTimeInventoryResults?.find(o => o.productId === parameter.productId);
}

export function getProductCollectionRealTimeInventory(parameter: GetProductCollectionRealTimeInventoryApiV2Parameter) {
    let url = realTimeInventoryUrl;

    /* Poolcorp Custom Code */
    let additionalQueryStringParameters = "";
    if (parameter.additionalQueryStringParameters){
        let index = 0;
        for (const key in parameter.additionalQueryStringParameters) {
            additionalQueryStringParameters += `${index>0?",":""}"${key}":"${encodeURIComponent(parameter.additionalQueryStringParameters[key])}"`;
            index++;
        }
        additionalQueryStringParameters = `&properties={${additionalQueryStringParameters}}`;
    }
    /* Poolcorp Custom Code */

    if (parameter.expand) {
        url += `?expand=${parameter.expand.join(",")}${additionalQueryStringParameters}`; // Poolcorp Custom Code
    }

    return post<GetProductCollectionRealTimeInventoryApiV2Parameter, RealTimeInventoryModel>(`${url}`, {
        productIds: parameter.productIds,
        configurations: parameter.configurations,
    });
} 